import axios from 'axios';
import { API_URL } from '../../../support/api';
import { PaginatedValue } from '../../../support/utils';
import { ICancellation } from '../models/Cancellation';

export const BASE_CANCELLATION_URL = `${API_URL}/v1/cancellation-requests`;

export const listCancellation = async (search = '', direction = 'asc') => {
  const URL = `${BASE_CANCELLATION_URL}/list?search=${search}&direction=${direction}`;
  const {
    data: { value },
  } = await axios.get<{ value: PaginatedValue<ICancellation> }>(URL);

  return value;
};

export const viewCancellation = async (id: number | string) => {
  const {
    data: { value },
  } = await axios.get<{ value: ICancellation }>(
    `${BASE_CANCELLATION_URL}/${id}/get`
  );

  return value;
};

export const deleteCancellation = async (payload: ICancellation) => {
  const {
    data: { value },
  } = await axios.post<{ value: ICancellation }>(
    `${BASE_CANCELLATION_URL}/${payload.id}/delete`,
    payload
  );

  return value;
};
